import React, { FormEvent } from "react";
import styles from "./NewAuthPageLayout.module.scss";
import logo from "./Op.svg?url";
import logo_orange from "./Op_orange.png?url";
import available from "src/assets/img/available-now.svg?url";
import Button from "../button/Button";
import { LordIcon } from "../lord-icon/lord-icon";
import AdCarousel, { CarouselSlide } from "./AdCarousel";
import { useGeolocation } from "@src/hooks";
import bgAdBeingWellNA from "./bg_ad_being_well_na.jpg?url";
import bgAdStandaloneLessonLibraryNA from "./bg_ad_standalone_lesson_library_na.jpg?url";
import bgAdProfessionalDevelopmentAU from "./bg_ad_professional_development_au.jpg?url";
import bgAdStandaloneLessonLibraryAU from "./bg_ad_standalone_lesson_library_au.jpg?url";

type Common = {
  children: React.ReactNode | any;
  title: React.ReactNode;
  loading: boolean;
  buttonTitle: string;
  onSubmit: (e: FormEvent) => void;
  backToLogin?: boolean;
  isParentAuth?: boolean;
  isRegistration?: boolean;
  disableLogin?: boolean;
  isSuccessful?: boolean;
};

type WithRender = {
  children: () => React.ReactNode;
};

type Props = Common | WithRender;

function NewAuthPageLayout(props: Props) {
  const { children } = props;
  const { title, isRegistration, onSubmit } = props as Common;

  // Use the reusable geolocation hook
  const { isAU, isNorthAmerica } = useGeolocation();

  const slides: CarouselSlide[] = [
    {
      id: 1,
      image: isNorthAmerica
        ? bgAdStandaloneLessonLibraryNA
        : bgAdStandaloneLessonLibraryAU,
      title: "Standalone Lessons",
    },
    {
      id: 2,
      image: isNorthAmerica ? bgAdBeingWellNA : bgAdProfessionalDevelopmentAU,
      title: "Professional Development",
    },
  ];

  return (
    <div className={isRegistration ? styles.registerPage : styles.page}>
      <div className={isRegistration ? styles.backBlur : styles.hidden}></div>
      <div className={styles.logo}>
        <img src={logo_orange} alt="logo" />
      </div>
      <div className={styles.pageContent}>
        <div className={styles.left}>
          {isRegistration ? (
            <div className={styles.registerLeftContent}>
              <div className={styles.bodyContainer}>
                <h1 className={styles.registerTitle}>
                  Teach Mental Health skills using Authentic Peer voices.
                </h1>
              </div>
            </div>
          ) : (
            <div className={styles.leftContent}>
              <AdCarousel
                slides={slides}
                autoPlay={true}
                autoPlayInterval={30000}
                showArrows={true}
                showDots={true}
              />
            </div>
          )}
        </div>
        <div className={styles.right}>
          <div
            className={styles.rightContent}
            style={
              isRegistration ? { height: "calc(100vh - 100px)" } : undefined
            }
          >
            <div className={styles.titleView}>{title}</div>
            {typeof children === "function" ? (
              children()
            ) : (
              <form className={styles.formClass} onSubmit={onSubmit}>
                {children}
              </form>
            )}
          </div>
        </div>
      </div>
      {/* {!isRegistration && <div className={styles.footerBar}></div>} */}
    </div>
  );
}

export default NewAuthPageLayout;
